import React, { useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Dialog from '@material-ui/core/Dialog'
import MuiDialogTitle from '@material-ui/core/DialogTitle'
import { Button } from '@material-ui/core'
import { PDFDownloadLink } from '@react-pdf/renderer'
import { GuideAnswersPdf } from './GuideAnswersPdf'

const PAGE_QUESTIONS = {
    1: [
        'Write your full name here.',
        'What camera and lens do you have?',
        'Can you check the date/time on your camera now and write it in here including AM/PM.',
        'What setting is your photo quality on?',
        'When you tested a photo what size was it?',
        'How many batteries do you have?',
    ],
    3: [
        'What burst setting should you use?',
        'How many photos of each competitor are we expecting?',
        'What editing software do we want you to use?',
    ],
    5: [
        'Go to www.speedtest.net and test your wifi speed. What is the upload and download speed?',
        'What is your backup plan if your Wifi or Computer fails?',
        'Login to https://www.bossfotos.com/photographer/map . What is the name of one of your galleries or the latest gallery?',
        'How do you delete a gallery?',
        'When should you start and finish loading the photos to Bossfotos?',
        'What and who do you inform when you start loading a gallery?',
        'Which browser should you use?',
    ],
}

export const QuestionnairePage = ({ pageIndex, title, allAnswers, savedAnswers, onSaveAndContinue, isLastQuestionnaire }) => {
    const classes = useStyles()
    const questions = PAGE_QUESTIONS[pageIndex] || []
    const [answers, setAnswers] = useState(savedAnswers)
    const [showDialog, setShowDialog] = useState(false)

    const updateAnswer = (index, value) => {
        setAnswers({ ...answers, [index]: value })
    }

    const handleSaveAndContinue = () => {
        onSaveAndContinue(answers)
    }

    const finalAnswers = { ...allAnswers, [pageIndex]: answers }

    return (
        <div className={classes.page}>
            <div className={classes.body}>
                {questions.map((question, i) => (
                    <div key={i} className={classes.question}>
                        <label className={classes.label}>{i + 1}) {question}</label>
                        <input
                            type="text"
                            className={classes.input}
                            value={answers[i] || ''}
                            onChange={(e) => updateAnswer(i, e.target.value)}
                        />
                    </div>
                ))}
            </div>
            {isLastQuestionnaire ? (
                <>
                    <button
                        className={classes.submitButton}
                        onClick={() => setShowDialog(true)}
                    >
                        Download Answers as PDF
                    </button>
                    <Dialog open={showDialog} onClose={() => setShowDialog(false)}>
                        <MuiDialogTitle className={classes.dialogTitle}>
                            Download
                        </MuiDialogTitle>
                        <div className={classes.dialogBody}>
                            When downloaded please forward to gav@bossfotos.com or his whatsapp.
                        </div>
                        <div className={classes.dialogButtons}>
                            <PDFDownloadLink
                                document={<GuideAnswersPdf allAnswers={finalAnswers} />}
                                fileName="documentation-guide-answers.pdf"
                            >
                                {({ loading }) => (
                                    <Button
                                        className={classes.dialogConfirmButton}
                                        variant="contained"
                                        onClick={() => setShowDialog(false)}
                                    >
                                        {loading ? 'Generating...' : 'OK'}
                                    </Button>
                                )}
                            </PDFDownloadLink>
                        </div>
                    </Dialog>
                </>
            ) : (
                <button
                    className={classes.submitButton}
                    onClick={handleSaveAndContinue}
                >
                    Save & Continue
                </button>
            )}
        </div>
    )
}

const useStyles = makeStyles({
    page: {
        backgroundColor: '#fff',
        borderRadius: 8,
        padding: 32,
        boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    },
    body: {
        marginBottom: 24,
    },
    question: {
        marginBottom: 20,
    },
    label: {
        display: 'block',
        fontSize: 14,
        fontWeight: 400,
        color: '#333',
        marginBottom: 8,
        lineHeight: 1.5,
    },
    input: {
        width: '100%',
        padding: '10px 12px',
        fontSize: 14,
        border: '1px solid #ddd',
        borderRadius: 4,
        boxSizing: 'border-box',
        fontFamily: 'inherit',
        '&:focus': {
            outline: 'none',
            borderColor: '#666',
        },
    },
    dialogTitle: {
        background: '#214986',
        color: '#ffffff',
        fontSize: 14,
        fontWeight: 600,
        padding: '12px 20px',
    },
    dialogBody: {
        padding: 20,
        fontSize: 13,
        lineHeight: 1.6,
    },
    dialogButtons: {
        display: 'flex',
        justifyContent: 'center',
        padding: '10px 20px 20px',
    },
    dialogConfirmButton: {
        background: '#214986',
        color: '#ffffff',
        fontWeight: 600,
        '&:hover': {
            background: '#1a3a6b',
        },
    },
    submitButton: {
        padding: '12px 32px',
        fontSize: 14,
        fontWeight: 500,
        color: '#fff',
        backgroundColor: '#333',
        border: 'none',
        borderRadius: 4,
        cursor: 'pointer',
        fontFamily: 'inherit',
        '&:hover': {
            backgroundColor: '#555',
        },
    },
})
